import React, { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import axios from "axios"

function RedirectToIncidents() {
  const navigate = useNavigate()
  const { user, login, logout } = useAuth()
  const searchParams = new URLSearchParams(window.location.search)

  const tokenFromUrl = searchParams.get("token")
  const emailFromUrl = searchParams.get("email")
  const userIdFromUrl = searchParams.get("userId")

  // Check if user already has a token in localStorage
  const existingToken = localStorage.getItem("token")
  const existingUser = user

  useEffect(() => {
    // If there's a token in the URL, validate it
    if (tokenFromUrl && emailFromUrl && userIdFromUrl) {
      const body = { email: emailFromUrl, userId: userIdFromUrl, token: tokenFromUrl }
      
      axios
        .post(process.env.REACT_APP_API_URL + "auth", body)
        .then((response) => {
          if (response.status === 200 && response.data.status === 200) {
            login({ email: emailFromUrl, userId: userIdFromUrl, name: response.data.username })
            localStorage.setItem("isAdmin", response.data.isAdmin)
            localStorage.setItem("token", response.data.token)
            localStorage.setItem(
              "tokenExpiration",
              response.data.tokenExpiration
            )
            alert(response.data.msg || "Logado com sucesso")
            navigate("/incident")
          } else {
            logout()
            localStorage.removeItem("isAdmin")
            localStorage.removeItem("token")
            localStorage.removeItem("tokenExpiration")
            const errorMessage = response.data?.message || response.data?.msg || "Erro na autenticação"
            alert(errorMessage)
            navigate("/login")
          }
        })
        .catch((error) => {
          const errorMessage = error.response?.data?.message || error.response?.data?.msg || "Erro na autenticação"
          alert(errorMessage)
          logout()
          navigate("/login")
        })
    } 
    // If user is already authenticated, redirect to incidents
    else if (existingToken && existingUser) {
      navigate("/incident")
    }
    // Otherwise, redirect to login
    else {
      navigate("/login")
    }
  }, [])

  return null
}

export default RedirectToIncidents
